// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"Bank_btnsWrap_2Xrd9"};